/**
 * Normalizuje imię/nazwę: trim + każde słowo zaczyna się wielką literą,
 * reszta małymi. Działa dla polskich znaków (`\p{L}`).
 *
 * Przykłady:
 *   "kasia"        → "Kasia"
 *   "  kasia "     → "Kasia"
 *   "ANNA"         → "Anna"
 *   "anna maria"   → "Anna Maria"
 *   "anna-maria"   → "Anna-Maria"
 *   "józef"        → "Józef"
 *
 * Używane przy zapisie member docu — niezależnie czy admin pisze przez
 * createMemberAccount, czy user przez self-edit (updateMember). Trzymanie
 * tego w DB layer = nikt nie zapomni znormalizować.
 */
export function normalizeName(s: string): string {
  return s
    .trim()
    .toLocaleLowerCase("pl-PL")
    .replace(/(^|[\s-])(\p{L})/gu, (m) => m.toLocaleUpperCase("pl-PL"));
}
